module.exports = __webpack_public_path__ + "img/DSC_0040.3d672e2c.jpg";